import styled from '@emotion/styled';
import { ColorType } from '~/types';

const Text = styled.p<{
  size?: 'sm' | 'smd' | 'md' | 'lg' | 'slg' | 'xs' | 'xsmd' | 'xxs' | 'xxsmd' | 'ssmd';
  align?: 'center' | 'left' | 'right';
  variant?: ColorType;
  isEnabled?: boolean;
}>`
  font-family: Poppins;

  color: ${({ variant, isEnabled }) =>
    variant === 'primary'
      ? 'var(--t-black)'
      : variant === 'themed'
        ? 'var(--prim4)'
        : variant === 'danger'
          ? 'var(--danger)'
          : variant === 'neutral'
            ? 'var(--neut3)'
            : variant === 'secondary'
              ? 'var(--text2)'
              : variant === 'success'
                ? 'var(--success)'
                : isEnabled === false
                  ? 'var(--neut5)'
                  : 'var(--t-black)'};

  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  text-align: ${({ align }) => align || 'left'};

  ${({ size }) => {
    switch (size) {
      case 'lg':
        return `
          font-size: 32px;
          font-weight: 600;
          line-height: 48px;
        `;
      case 'slg':
        return `
          font-size: 28px;
          font-weight: 600;
          line-height: 48px;
        `;
      case 'md':
        return `
          font-size: 24px;
          font-weight: 500;
          line-height: 36px;
        `;
      case 'smd':
        return `
          font-size: 20px;
          font-weight: 500;
          line-height: normal;
        `;
      case 'ssmd':
        return `
          font-size: 18px;
          font-weight: 500;
          line-height: normal;
        `;
      case 'sm':
        return `
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
        `;
      case 'xs':
        return `
          font-size: 14px;
          font-weight: 400;
          line-height: 21px;
        `;
      case 'xsmd':
        return `
          font-size: 14px;
          font-weight: 500;
          line-height: 21px;
        `;
      case 'xxs':
        return `
          font-size: 10px;
          font-weight: 400;
          line-height: 15px;
        `;
      case 'xxsmd':
        return `
        font-size: 10px;
        font-weight: 500;
        line-height: 15px;
      `;
      default:
        return `
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
        `;
    }
  }}
`;

export default Text;
